import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbSharepointCustom: BowlBlock = withIntegration(options.slug.llmKbSharepointCustom, [
  {
    name: 'clientId',
    type: 'withText',
  },
  {
    name: 'clientSecret',
    type: 'withText',
  },
  {
    name: 'tenantId',
    type: 'withText',
    required: false,
  },
  {
    name: 'site_id',
    type: 'withText',
  },
  {
    name: 'folder_id',
    type: 'withText',
    required: false,
  },
  {
    name: 'drive_id',
    type: 'withText',
    required: false,
  },
  {
    name: 'tagsToInclude',
    type: 'array',
    fields: [
      {
        type: 'row',
        fields: [
          {
            name: 'columnName',
            type: 'text',
          },
          {
            name: 'columnValues',
            type: 'text',
            hasMany: true,
          },
        ],
      },
    ],
  },
  {
    name: 'tagsToExclude',
    type: 'array',
    fields: [
      {
        type: 'row',
        fields: [
          {
            name: 'columnName',
            type: 'text',
          },
          {
            name: 'columnValues',
            type: 'text',
            hasMany: true,
          },
        ],
      },
    ],
  },
  {
    name: 'recursive',
    type: 'checkbox',
    required: false,
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
    required: false,
  },
]);
